import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../assets/img/logo/evnet.png";

import {
  Reveal,
  MagneticCTA,
  AnimatedCounter,
} from "../motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import about3 from "../assets/img/about/about.jpeg";

// Brochure images
import decorPurpleTree from "../images/brochure/decor_purple_tree.jpg";
import cateringPink from "../images/brochure/catering_pink.jpg";
import planningDining from "../images/brochure/planning_dining.jpg";
import forumQatarUkPanel from "../images/brochure/forum_qatar_uk_panel.jpg";
import forumGermanyMerkel from "../images/brochure/forum_germany_merkel.jpg";
import forumGermanyPanel from "../images/brochure/forum_germany_panel.jpg";
import cameraStudio from "../images/brochure/camera_studio.jpg";
import weddingPurplePillars from "../images/brochure/wedding_purple_pillars.jpg";
import weddingWhiteDrapes from "../images/brochure/wedding_white_drapes.jpg";
import outdoorFlags from "../images/brochure/outdoor_flags.jpg";
import nationalDayDecor from "../images/brochure/national_day_decor.jpg";
import sportsDayHall from "../images/brochure/sports_day_hall.jpg";
import ribbonCutting1 from "../images/brochure/ribbon_cutting_1.jpg";
import confSecurityStage from "../images/brochure/conf_security_stage.jpg";
import maltaDignitaries from "../images/brochure/malta_dignitaries.jpg";
import exhibitTunisiaBooth from "../images/brochure/exhibit_tunisia_booth.jpg";
import forumGermanyEmir from "../images/brochure/forum_germany_emir.jpg";
import forumQatarUkStage from "../images/brochure/forum_qatar_uk_stage.jpg";
import eventDignitaries from "../images/brochure/event_dignitaries.jpg";
import eventDeloitte from "../images/brochure/event_deloitte.jpg";
import exhibitRealEstate from "../images/brochure/exhibit_real_estate.jpg";
import exhibitTunisiaVisit from "../images/brochure/exhibit_tunisia_visit.jpg";
import maltaDiplomatic from "../images/brochure/malta_diplomatic.jpg";
import maltaDinner from "../images/brochure/malta_dinner.jpg";
import maltaExhibit from "../images/brochure/malta_exhibit.jpg";
import mediaPress1 from "../images/brochure/media_press_1.jpg";
import mediaPress2 from "../images/brochure/media_press_2.jpg";
import mediaPress3 from "../images/brochure/media_press_3.jpg";
import mediaPressStack from "../images/brochure/media_press_stack.jpg";
import interviewMedia from "../images/brochure/interview_media.jpg";
import conferenceHall from "../images/brochure/conference_hall.jpg";
import decorLoungePurple from "../images/brochure/decor_lounge_purple.jpg";
import render3dHall from "../images/brochure/render_3d_hall.jpg";
import delegatesWalkthrough from "../images/brochure/delegates_walkthrough.jpg";
// import backOffice from "../images/brochure/back_office.jpg";

// Events images (new portfolio screenshots)
import evImg01 from "../images/events images/ev_screenshot_01.jpg";
import evImg02 from "../images/events images/ev_screenshot_02.jpg";
import evImg03 from "../images/events images/ev_screenshot_03.jpg";
import evImg04 from "../images/events images/ev_screenshot_04.jpg";
import evImg05 from "../images/events images/ev_screenshot_05.jpg";
import evImg06 from "../images/events images/ev_screenshot_06.jpg";
import evImg07 from "../images/events images/ev_screenshot_07.jpg";
import evImg08 from "../images/events images/ev_screenshot_08.jpg";
import evImg09 from "../images/events images/ev_screenshot_09.jpg";
import evImg10 from "../images/events images/ev_screenshot_10.jpg";
import evImg11 from "../images/events images/ev_screenshot_11.jpg";
import evImg12 from "../images/events images/ev_screenshot_12.jpg";
import evImg13 from "../images/events images/ev_screenshot_13.jpg";
import evImg14 from "../images/events images/ev_screenshot_14.jpg";
import evImg15 from "../images/events images/ev_screenshot_15.jpg";

// Partners
import evp01 from "../images/events partners/evp_01.jpg";
import evp02 from "../images/events partners/evp_02.jpg";
import evp03 from "../images/events partners/evp_03.jpg";
import evp04 from "../images/events partners/evp_04.jpg";
import evp05 from "../images/events partners/evp_05.jpg";
import evp06 from "../images/events partners/evp_06.jpg";
import evp07 from "../images/events partners/evp_07.jpg";
import evp08 from "../images/events partners/evp_08.jpg";
import evp09 from "../images/events partners/evp_09.jpg";
import evp10 from "../images/events partners/evp_10.jpg";
import evp11 from "../images/events partners/evp_11.jpg";

import "../events-enhanced.css";
import "../events-redesign.css";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";
import Select from "react-select";
import { Modal, ModalBody } from "reactstrap";

import {
  ArrowUpRight,
  ChevronRight,
  MapPin,
  Phone,
  Mail,
  Clock,
  Image as ImageIcon,
} from "lucide-react";

// ─── DATA ───────────────────────────────────────────
const eventsPartnerLogos = [
  evp01, evp02, evp03, evp04, evp05, evp06, evp07, evp08, evp09, evp10, evp11,
];

// All portfolio images
const portfolioImages = [
  { src: forumQatarUkPanel, tag: "Conference", title: "Qatar–UK Business & Investment Forum" },
  { src: forumGermanyMerkel, tag: "Forum", title: "Qatar–Germany Investment Forum" },
  { src: forumGermanyEmir, tag: "Forum", title: "Qatar–Germany Summit" },
  { src: forumGermanyPanel, tag: "Conference", title: "Business Panel Discussion" },
  { src: forumQatarUkStage, tag: "Conference", title: "Plenary Stage" },
  { src: weddingPurplePillars, tag: "Wedding", title: "Royal Hall Wedding Décor" },
  { src: weddingWhiteDrapes, tag: "Décor", title: "Crystal Drapes & Floral Stage" },
  { src: conferenceHall, tag: "Conference", title: "Premium Conference Setup" },
  { src: delegatesWalkthrough, tag: "Conference", title: "Delegate Walkthrough" },
  { src: confSecurityStage, tag: "Summit", title: "Global Security & Stability" },
  { src: eventDignitaries, tag: "Diplomatic", title: "Dignitaries Reception" },
  { src: eventDeloitte, tag: "Corporate", title: "Deloitte Event" },
  { src: maltaDignitaries, tag: "Diplomatic", title: "Diplomatic Reception, Malta" },
  { src: maltaDiplomatic, tag: "Diplomatic", title: "Malta Diplomatic Gathering" },
  { src: maltaDinner, tag: "Gala", title: "Gala Dinner, Malta" },
  { src: maltaExhibit, tag: "Exhibition", title: "Malta Exhibition Booth" },
  { src: exhibitTunisiaBooth, tag: "Exhibition", title: "Tunisia Tourism Pavilion" },
  { src: exhibitTunisiaVisit, tag: "Exhibition", title: "Tunisia Pavilion Visit" },
  { src: exhibitRealEstate, tag: "Exhibition", title: "Real Estate Exhibition" },
  { src: ribbonCutting1, tag: "Inauguration", title: "Tunisia Pavilion Opening" },
  { src: sportsDayHall, tag: "Sports", title: "National Sports Day" },
  { src: nationalDayDecor, tag: "National Day", title: "Qatar National Day" },
  { src: outdoorFlags, tag: "Outdoor", title: "Outdoor Activation" },
  { src: cateringPink, tag: "Catering", title: "Premium Banquet" },
  { src: cameraStudio, tag: "Production", title: "Broadcast Production" },
  { src: mediaPress1, tag: "Media", title: "Press Conference" },
  { src: mediaPress2, tag: "Media", title: "Media Coverage" },
  { src: mediaPress3, tag: "Media", title: "Press Briefing" },
  { src: mediaPressStack, tag: "Media", title: "Press Materials" },
  { src: interviewMedia, tag: "Media", title: "Media Interview" },
  { src: planningDining, tag: "Planning", title: "Event Planning Session" },
  { src: decorPurpleTree, tag: "Décor", title: "Purple Theme Décor" },
  // { src: backOffice, tag: "Operations", title: "Back Office Coordination" },
  // New events images
  { src: evImg01, tag: "Portfolio", title: "Event Portfolio 01" },
  { src: evImg02, tag: "Portfolio", title: "Event Portfolio 02" },
  { src: evImg03, tag: "Portfolio", title: "Event Portfolio 03" },
  { src: evImg04, tag: "Portfolio", title: "Event Portfolio 04" },
  { src: evImg05, tag: "Portfolio", title: "Event Portfolio 05" },
  { src: evImg06, tag: "Portfolio", title: "Event Portfolio 06" },
  { src: evImg07, tag: "Portfolio", title: "Event Portfolio 07" },
  { src: evImg08, tag: "Portfolio", title: "Event Portfolio 08" },
  { src: evImg09, tag: "Portfolio", title: "Event Portfolio 09" },
  { src: evImg10, tag: "Portfolio", title: "Event Portfolio 10" },
  { src: evImg11, tag: "Portfolio", title: "Event Portfolio 11" },
  { src: evImg12, tag: "Portfolio", title: "Event Portfolio 12" },
  { src: evImg13, tag: "Portfolio", title: "Event Portfolio 13" },
  { src: evImg14, tag: "Portfolio", title: "Event Portfolio 14" },
  { src: evImg15, tag: "Portfolio", title: "Event Portfolio 15" },
];

const heroSlides = [
  { image: weddingPurplePillars },
  { image: evImg05 },
  { image: conferenceHall },
  { image: decorLoungePurple },
  { image: maltaExhibit },
  { image: planningDining },
  { image: render3dHall },
];

const defaultEventServices = [
  {
    title: "Event Strategy",
    titleFR: "Stratégie d'événement",
    titleAR: "استراتيجية الفعاليات",
    description:
      "Tailored event strategies aligned with your brand, audience and KPIs — from concept and budgeting to post-event ROI analysis.",
    descriptionFR:
      "Stratégies d'événements sur mesure alignées avec votre marque, votre public et vos KPIs — du concept et budget à l'analyse du ROI.",
    descriptionAR:
      "استراتيجيات فعاليات مخصصة تتوافق مع علامتك التجارية وجمهورك ومؤشرات الأداء — من الفكرة والميزانية إلى تحليل العائد على الاستثمار.",
  },
  {
    title: "Conference Planning",
    titleFR: "Planification de conférences",
    titleAR: "تخطيط المؤتمرات",
    description:
      "End-to-end conference management: venue scouting, speaker coordination, agenda design, AV production and on-site logistics.",
    descriptionFR:
      "Gestion complète de conférences : recherche de lieu, coordination des intervenants, programme, production AV et logistique sur site.",
    descriptionAR:
      "إدارة شاملة للمؤتمرات: اختيار المكان، وتنسيق المتحدثين، وتصميم جدول الأعمال، والإنتاج السمعي البصري، واللوجستيات في الموقع.",
  },
  {
    title: "Media Coverage",
    titleFR: "Couverture médiatique",
    titleAR: "التغطية الإعلامية",
    description:
      "Multi-platform media coverage including photography, videography, livestreaming and social media amplification.",
    descriptionFR:
      "Couverture médiatique multi-plateforme : photographie, vidéographie, streaming en direct.",
    descriptionAR:
      "تغطية إعلامية متعددة المنصات تشمل التصوير والفيديو والبث المباشر.",
  },
  {
    title: "Workshops & Seminars",
    titleFR: "Ateliers et séminaires",
    titleAR: "ورش عمل وندوات",
    description:
      "Interactive workshops and seminars with curated facilitators, custom curricula and immersive learning environments.",
    descriptionFR:
      "Ateliers et séminaires interactifs avec facilitateurs sélectionnés.",
    descriptionAR:
      "ورش عمل وندوات تفاعلية مع ميسرين منتقين.",
  },
  {
    title: "Product Launches",
    titleFR: "Lancements de produits",
    titleAR: "إطلاق المنتجات",
    description:
      "Show-stopping product launches with creative theming, choreographed reveals, press coverage and integrated digital campaigns.",
    descriptionFR:
      "Lancements de produits spectaculaires avec scénographie créative.",
    descriptionAR:
      "إطلاق منتجات يخطف الأنظار مع تصميم إبداعي.",
  },
  {
    title: "Exhibitions & Booths",
    titleFR: "Expositions et stands",
    titleAR: "المعارض والأجنحة",
    description:
      "Custom exhibition stands and immersive booth design — from 3D rendering and fabrication to staffing and lead capture.",
    descriptionFR:
      "Stands d'exposition personnalisés et conception immersive.",
    descriptionAR:
      "أجنحة معارض مخصصة وتصميم غامر.",
  },
  {
    title: "Awards Ceremonies",
    titleFR: "Cérémonies de remise de prix",
    titleAR: "حفلات توزيع الجوائز",
    description:
      "Memorable awards nights with red-carpet experiences, broadcast-quality production, host coordination and bespoke trophies.",
    descriptionFR:
      "Soirées de remise de prix mémorables : expériences tapis rouge.",
    descriptionAR:
      "حفلات جوائز لا تُنسى بتجارب السجادة الحمراء.",
  },
  {
    title: "Press Conferences",
    titleFR: "Conférences de presse",
    titleAR: "المؤتمرات الصحفية",
    description:
      "Strategic press conferences with media list curation, press kit creation and full on-site relations support.",
    descriptionFR:
      "Conférences de presse stratégiques avec sélection des médias.",
    descriptionAR:
      "مؤتمرات صحفية استراتيجية مع تنسيق القوائم الإعلامية.",
  },
];

const defaultEventProjects = [
  {
    name: "Qatar–UK Business & Investment Forum",
    nameFR: "Forum d'affaires Qatar–Royaume-Uni",
    nameAR: "منتدى قطر والمملكة المتحدة للأعمال والاستثمار",
    client: "London · March 2017",
    clientFR: "Londres · Mars 2017",
    clientAR: "لندن · مارس 2017",
    description: "A high-profile business forum connecting Qatari and British investors, featuring keynote sessions, panel discussions, and networking events at Lancaster House, London.",
    descriptionFR: "Un forum d'affaires de haut niveau réunissant des investisseurs qataris et britanniques.",
    descriptionAR: "منتدى أعمال رفيع المستوى يربط المستثمرين القطريين والبريطانيين.",
    images: [forumQatarUkPanel],
  },
  {
    name: "Qatar–Germany Business & Investment Forum",
    nameFR: "Forum Qatar–Allemagne pour les affaires",
    nameAR: "منتدى قطر وألمانيا للأعمال والاستثمار",
    client: "Berlin · September 2018",
    clientFR: "Berlin · Septembre 2018",
    clientAR: "برلين · سبتمبر 2018",
    description: "A landmark investment forum between Qatar and Germany, held at the Chancellery in Berlin with high-level governmental and business delegations.",
    descriptionFR: "Un forum d'investissement historique entre le Qatar et l'Allemagne.",
    descriptionAR: "منتدى استثماري تاريخي بين قطر وألمانيا.",
    images: [forumGermanyMerkel],
  },
  {
    name: "Global Security & Stability Conference",
    nameFR: "Conférence sur la sécurité et la stabilité mondiales",
    nameAR: "مؤتمر الأمن والاستقرار الدولي",
    client: "Doha · State of Qatar",
    clientFR: "Doha · État du Qatar",
    clientAR: "الدوحة · دولة قطر",
    description: "An international security conference gathering global leaders and experts to discuss geopolitical stability, security challenges and strategic cooperation.",
    descriptionFR: "Une conférence internationale sur la sécurité réunissant des leaders mondiaux.",
    descriptionAR: "مؤتمر أمني دولي يجمع قادة وخبراء عالميين.",
    images: [confSecurityStage],
  },
  {
    name: "Qatar National Sports Day",
    nameFR: "Journée nationale du sport du Qatar",
    nameAR: "اليوم الرياضي الوطني لقطر",
    client: "Ministry of Education",
    clientFR: "Ministère de l'éducation",
    clientAR: "وزارة التعليم",
    description: "A nationwide sports activation event featuring outdoor activities, competitions and community engagement programs across multiple venues in Qatar.",
    descriptionFR: "Un événement sportif national avec des activités en plein air.",
    descriptionAR: "فعالية رياضية وطنية مع أنشطة خارجية ومسابقات.",
    images: [sportsDayHall],
  },
  {
    name: "Diplomatic Reception in Valletta",
    nameFR: "Réception diplomatique à La Valette",
    nameAR: "استقبال دبلوماسي في فاليتا",
    client: "Republic of Malta",
    clientFR: "République de Malte",
    clientAR: "جمهورية مالطا",
    description: "An exclusive diplomatic reception held in Valletta, Malta, bringing together international dignitaries and business leaders for high-level networking.",
    descriptionFR: "Une réception diplomatique exclusive à La Valette, Malte.",
    descriptionAR: "استقبال دبلوماسي حصري في فاليتا، مالطا.",
    images: [maltaDignitaries],
  },
  {
    name: "Tunisia Tourism Pavilion",
    nameFR: "Pavillon du tourisme tunisien",
    nameAR: "جناح السياحة التونسية",
    client: "Discover Tunisia",
    clientFR: "Découvrez la Tunisie",
    clientAR: "اكتشف تونس",
    description: "A dedicated tourism pavilion showcasing Tunisian culture, heritage and travel destinations at a major international exhibition.",
    descriptionFR: "Un pavillon touristique dédié à la culture tunisienne.",
    descriptionAR: "جناح سياحي مخصص يعرض الثقافة والتراث التونسي.",
    images: [exhibitTunisiaBooth],
  },
];

const defaultEventConfigurations = {
  phone: "+97444303443",
  email: "sales@hmatechs.com",
  address: "QFC Tower, Doha, Qatar",
  addressFR: "Tour QFC, Doha, Qatar",
  addressAR: "برج QFC، الدوحة، قطر",
  openingDayStart: "Sunday",
  openingDayStartFR: "Dimanche",
  openingDayStartAR: "الأحد",
  openingDayEnd: "Thursday",
  openingDayEndFR: "Jeudi",
  openingDayEndAR: "الخميس",
  openingHourStart: "9:00 AM",
  openingHourStartFR: "9h00",
  openingHourStartAR: "9:00 صباحًا",
  openingHourEnd: "6:00 PM",
  openingHourEndFR: "18h00",
  openingHourEndAR: "6:00 مساءً",
};

const servicesList = [
  "CONFERENCE", "EXHIBITION", "WEDDING", "CATERING", "INSURANCE", "SERVICES", "MEDIA"
];

// ─── COMPONENT ──────────────────────────────────────
const Events = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [fullName, setfullName] = useState([]);
  const [skype, setskype] = useState([]);
  const [lang, setlang] = useState({ value: "EN", label: "EN" });
  const [phone, setphone] = useState([]);
  const [email, setemail] = useState([]);
  const [message, setmessage] = useState([]);

  const [modalopen, setmodalopen] = useState(false);
  const [item, setitem] = useState({});

  const [menu, setmenu] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [portfolioLightbox, setPortfolioLightbox] = useState(null);
  const [activeFilter, setActiveFilter] = useState("All");
  const [galleryCount, setGalleryCount] = useState(12);
  const [serviceModal, setServiceModal] = useState(null);

  const galleryFilters = ["All", "Conference", "Wedding", "Exhibition", "Diplomatic", "Media", "Events"];

  const tagToFilter = (tag) => ({
    Conference: "Conference", Forum: "Conference", Summit: "Conference",
    Wedding: "Wedding", Décor: "Wedding",
    Exhibition: "Exhibition",
    Diplomatic: "Diplomatic",
    Media: "Media", Production: "Media",
    "National Day": "Events", Outdoor: "Events", Inauguration: "Events",
    Catering: "Events", Sports: "Events", Portfolio: "Events",
  }[tag] || "Events");

  const filteredGallery = activeFilter === "All"
    ? portfolioImages
    : portfolioImages.filter((item) => tagToFilter(item.tag) === activeFilter);

  const closeProjectModal = () => setSelectedProject(null);
  const openProjectModal = (project) => setSelectedProject(project);

  document.documentElement.dir = lang.value === "AR" && "rtl";

  const tr = (en, fr, ar) =>
    lang.value === "EN" ? en : lang.value === "FR" ? fr : ar;

  useEffect(() => {
    const onScroll = () => {
      const h = document.querySelector("header.header");
      if (!h) return;
      h.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menu) {
      document.body.style.overflow = "hidden";
      const onKey = (e) => e.key === "Escape" && setmenu(false);
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = "";
        window.removeEventListener("keydown", onKey);
      };
    }
  }, [menu]);

  const navHash = (hash) => (e) => {
    e.preventDefault();
    setmenu(false);
    requestAnimationFrame(() => {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    });
  };

  const navRoute = (path) => (e) => {
    e.preventDefault();
    setmenu(false);
    setTimeout(() => navigate(path), 80);
  };

  useEffect(() => {
    if (
      localStorage.getItem("lang") &&
      JSON.parse(localStorage.getItem("lang"))
    ) {
      setlang(JSON.parse(localStorage.getItem("lang")));
    }
  }, []);

  const services =
    Array.isArray(data?.Service) && data.Service.length > 0
      ? data.Service
      : defaultEventServices;
  const projects =
    Array.isArray(data?.Project) && data.Project.length > 0
      ? data.Project
      : defaultEventProjects;
  const partners = Array.isArray(data?.Parteners) ? data.Parteners : [];
  const config = isEmpty(data?.Configurations)
    ? defaultEventConfigurations
    : data.Configurations;

  const addContact = async () => {
    await axios
      .post("https://hmatechs.com/api/contact", {
        fullName,
        skype,
        phone,
        email,
        message,
      })
      .then((response) => {})
      .catch(function (err) {});
  };

  return (
    <div className="ev-page">
      <header className="header">
        <div className="container">
          <nav>
            <a href="#homeid" onClick={navHash("homeid")}>
              <div className="logo">
                <img src={Logo} alt="HMA Events" />
              </div>
            </a>

            <input
              type="checkbox"
              id="checkbox"
              checked={menu}
              onChange={(e) => setmenu(e.target.checked)}
            />
            <label htmlFor="checkbox" id="icon" aria-label="Toggle menu">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d={menu ? "M6 6L18 18M6 18L18 6" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </label>

            <ul onClick={(e) => e.target === e.currentTarget && setmenu(false)}>
              <li><a href="#homeid" onClick={navHash("homeid")}>{tr("Home", "Accueil", "الصفحة الرئيسية")}</a></li>
              <li><a href="#aboutid" onClick={navHash("aboutid")}>{tr("About", "À propos", "معلومات عنا")}</a></li>
              <li><a href="#servicesid" onClick={navHash("servicesid")}>{tr("Services", "Services", "خدمات")}</a></li>
              <li><a href="#projectsid" onClick={navHash("projectsid")}>{tr("Portfolio", "Portefeuille", "المشاريع")}</a></li>
              <li><a href="#galleryid" onClick={navHash("galleryid")}>{tr("Gallery", "Galerie", "المعرض")}</a></li>
              <li><a href="/clients" onClick={navRoute("/clients")}>{tr("Clients", "Clients", "العملاء")}</a></li>
              <li><a href="/" onClick={navRoute("/")}>{tr("HMA Techs", "HMA Techs", "إتش إم إي تكس")}</a></li>
            </ul>

            <Select
              className="selectLang"
              isSearchable={false}
              theme={(theme) => ({
                ...theme, borderStyle: "none", boxShadow: "none",
                colors: { ...theme.colors, neutral0: "#0d0c1c", neutral30: "#0d0c1c", neutral10: "#fff", neutral50: "#000", neutral80: "#fff", primary25: "#ccc", primary: "#238aec", primary50: "#238aec" },
              })}
              styles={{ control: (base) => ({ ...base, border: 0, boxShadow: "none" }), option: (base) => ({ ...base, color: "#fff" }) }}
              value={lang}
              onChange={(val) => { setlang(val); localStorage.setItem("lang", JSON.stringify(val)); }}
              options={[{ value: "EN", label: "EN" }, { value: "FR", label: "FR" }, { value: "AR", label: "AR" }]}
            />
          </nav>
        </div>
      </header>

      {createPortal(
        <AnimatePresence>
          {menu && (
            <motion.div
              key="mobile-menu"
              className="hma-mobile-menu"
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}
              onClick={(e) => e.target === e.currentTarget && setmenu(false)}
            >
              <button type="button" className="hma-mobile-menu__close" onClick={() => setmenu(false)} aria-label="Close menu">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M6 6L18 18M6 18L18 6" strokeLinecap="round" /></svg>
              </button>
              <span className="hma-mobile-menu__eyebrow">{tr("Menu", "Menu", "القائمة")}</span>
              <ul className="hma-mobile-menu__list">
                {[
                  { hash: "homeid", labels: ["Home", "Accueil", "الصفحة الرئيسية"] },
                  { hash: "aboutid", labels: ["About", "À propos", "معلومات عنا"] },
                  { hash: "servicesid", labels: ["Services", "Services", "خدمات"] },
                  { hash: "projectsid", labels: ["Portfolio", "Portefeuille", "المشاريع"] },
                  { hash: "galleryid", labels: ["Gallery", "Galerie", "المعرض"] },
                  { hash: "contactid", labels: ["Contact", "Contact", "اتصال"] },
                ].map((item, i) => (
                  <motion.li key={item.hash}
                    initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 + i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <a href={`#${item.hash}`} onClick={navHash(item.hash)}>
                      <span className="hma-mobile-menu__num">{String(i + 1).padStart(2, "0")}</span>
                      <span className="hma-mobile-menu__label">{tr(item.labels[0], item.labels[1], item.labels[2])}</span>
                    </a>
                  </motion.li>
                ))}
              </ul>
              <motion.a href="/clients" onClick={navRoute("/clients")} className="hma-mobile-menu__cta" style={{ marginTop: 8 }}
                initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.5 }}
              >{tr("Clients →", "Clients →", "العملاء →")}</motion.a>
              <motion.a href="/" onClick={navRoute("/")} className="hma-mobile-menu__cta"
                initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55, duration: 0.5 }}
              >{tr("HMA Techs →", "HMA Techs →", "إتش إم إي تكس →")}</motion.a>
              <motion.div className="hma-mobile-menu__lang"
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.65, duration: 0.4 }}
              >
                <span className="hma-mobile-menu__lang-label">{tr("Language", "Langue", "اللغة")}</span>
                <div className="hma-mobile-menu__lang-group" role="group">
                  {[{ value: "EN", label: "EN" }, { value: "FR", label: "FR" }, { value: "AR", label: "AR" }].map((opt) => (
                    <button key={opt.value} type="button"
                      className={`hma-mobile-menu__lang-btn ${lang.value === opt.value ? "is-active" : ""}`}
                      onClick={() => { setlang(opt); localStorage.setItem("lang", JSON.stringify(opt)); }}
                    >{opt.label}</button>
                  ))}
                </div>
              </motion.div>
              <span className="hma-mobile-menu__footer">ULTIMATE · EXCELLENCY</span>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}

      {/* ═══════════════ HERO ═══════════════ */}
      <section className="ev-hero" id="homeid">
        <Swiper
          slidesPerView={1}
          speed={600}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop
          modules={[Autoplay, Pagination]}
          pagination={{ clickable: true }}
          className="ev-hero-slider"
        >
          {heroSlides.map((slide, i) => (
            <SwiperSlide key={i}>
              <div className="ev-hero-slide" style={{ backgroundImage: `url(${slide.image})` }} />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="ev-hero-overlay" />

        <div className="ev-hero-content">
          <motion.span className="ev-hero-eyebrow"
            initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
          >{tr("Ultimate Excellency", "Excellence Ultime", "التميز المطلق")}</motion.span>

          <motion.h1 className="ev-hero-title"
            initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          >
            {tr("Crafting events that ", "Créer des événements qui ", "نصنع فعاليات ")}
            <em>{tr("define legacy", "marquent l'histoire", "تترك أثرًا")}</em>
          </motion.h1>

          <motion.p className="ev-hero-sub"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.7 }}
          >
            {tr(
              "From state forums in London and Berlin to bespoke royal weddings in Doha — HMA Events delivers strategy, design and flawless execution for the region's most demanding occasions.",
              "Des forums d'État à Londres et Berlin aux mariages royaux à Doha — HMA Events offre stratégie, design et exécution irréprochable.",
              "من المنتديات الرسمية في لندن وبرلين إلى حفلات الزفاف الملكية في الدوحة — تقدم اتش أم أي إيفنتس الاستراتيجية والتصميم والتنفيذ الفائق."
            )}
          </motion.p>

          <motion.div className="ev-hero-actions"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 1 }}
          >
            <MagneticCTA>
              <a href="#projectsid" className="ev-btn-primary">
                {tr("Explore Portfolio", "Voir le portfolio", "استكشف الأعمال")}
                <ChevronRight size={18} />
              </a>
            </MagneticCTA>
            <MagneticCTA>
              <a href="#contactid" className="ev-btn-ghost">
                {tr("Plan Your Event", "Planifier votre événement", "خطط لفعاليتك")}
              </a>
            </MagneticCTA>
          </motion.div>

          <motion.div className="ev-hero-stats"
            initial="hidden" animate="visible" transition={{ staggerChildren: 0.12, delayChildren: 1.3 }}
          >
            {[
              { num: 12, suffix: "+", label: tr("Years", "Ans", "سنوات") },
              { num: 350, suffix: "+", label: tr("Events Delivered", "Événements livrés", "فعالية منفذة") },
              { num: 40, suffix: "+", label: tr("Government Clients", "Clients gouvernementaux", "جهة حكومية") },
            ].map((s, i) => (
              <motion.div key={i} variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7 } } }}>
                <div className="ev-hero-stat-num"><AnimatedCounter value={s.num} suffix={s.suffix} /></div>
                <span className="ev-hero-stat-label">{s.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="ev-scroll-indicator">
          <span>{tr("Scroll", "Défiler", "استمر")}</span>
          <motion.div className="ev-scroll-line"
            animate={{ scaleY: [0, 1, 0], opacity: [0.3, 1, 0.3] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
      </section>

      {/* ═══════════════ PARTNERS (animated) ═══════════════ */}
      <motion.section
        className="ev-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div className="ev-section-header"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          >
            <span className="ev-section-tag">
              <span className="ev-section-tag-dot" />
              {tr("Trusted Partners", "Partenaires de confiance", "الشركاء")}
            </span>
            <h2 className="ev-section-title">
              {tr("Our Valued Partners", "Nos partenaires de valeur", "شركاؤنا المقدرون")}
            </h2>
          </motion.div>

          <motion.div
            className="ev-partners-grid"
            initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-50px" }}
            variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.04, delayChildren: 0.1 } } }}
          >
            {eventsPartnerLogos.map((src, i) => (
              <motion.div
                key={i} className="ev-partner-card"
                variants={{ hidden: { opacity: 0, y: 30, scale: 0.9 }, visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } } }}
                whileHover={{ y: -8, scale: 1.02 }}
              >
                <motion.img src={src} alt={`Partner ${i + 1}`} whileHover={{ scale: 1.12 }} />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* ═══════════════ ABOUT ═══════════════ */}
      <section className="ev-section ev-section-alt" id="aboutid">
        <div className="ev-watermark ev-watermark--right">About.</div>
        <div className="container">
          <div className="ev-about-grid">
            <Reveal y={30} duration={1.0} className="ev-about-text">
              <span className="ev-section-tag">
                <span className="ev-section-tag-dot" />
                {tr("About Us", "À propos de nous", "معلومات عنا")}
              </span>
              <h3>
                {tr("Where ", "Là où ", "حيث ")}
                <em>{tr("strategy", "la stratégie", "تلتقي الاستراتيجية")}</em>
                <br />
                {tr("meets spectacle", "rencontre le spectacle", "بالفخامة")}
              </h3>
              <p>
                {isEmpty(data?.About)
                  ? lang.value === "EN"
                    ? "As a premier Event Coordination Company in QATAR, HMA Event is your one stop shop for wedding planner and event coordination, Conferences, Consulting, Media, Services. We take the headache out of trying to choose the best professionals, coordinating attendee lists, and developing an event that everyone will remember."
                    : lang.value === "FR"
                    ? "En tant que société de coordination d'événements de premier plan au QATAR, HMA Event est votre guichet unique pour la planification de mariages et la coordination d'événements, conférences, conseil, médias, services. Nous vous épargnons les maux de tête liés au choix des meilleurs professionnels, à la coordination des listes de participants et à l'élaboration d'un événement dont tout le monde se souviendra."
                    : "باعتبارنا شركة رائدة في تنسيق الفعاليات في قطر، فإن إتش إم أي إيفنت هي وجهتك المتكاملة لتخطيط الزفاف وتنسيق الفعاليات والمؤتمرات والاستشارات والإعلام والخدمات. نوفر عليك عناء اختيار أفضل المحترفين وتنسيق قوائم الحضور وتطوير فعالية لا تُنسى."
                  : lang.value === "EN" ? data?.About?.description
                  : lang.value === "FR" ? data?.About?.descriptionFR
                  : data?.About?.descriptionAR}
              </p>
              <MagneticCTA>
                <a href="#contactid" className="ev-btn-primary" style={{ display: "inline-flex" }}>
                  {tr("Get in Touch", "Entrer en contact", "تواصل معنا")}
                  <ArrowUpRight size={18} />
                </a>
              </MagneticCTA>
            </Reveal>

            <Reveal y={30} duration={1.0} delay={0.15}>
              <div className="ev-about-image-grid">
                <motion.img src={isEmpty(data?.About) ? weddingPurplePillars : data?.About?.image2} alt="" whileHover={{ scale: 1.02 }} transition={{ duration: 0.5 }} />
                <motion.img src={isEmpty(data?.About) ? forumQatarUkPanel : data?.About?.image1} alt="" whileHover={{ scale: 1.02 }} transition={{ duration: 0.5 }} />
                <motion.img src={isEmpty(data?.About) ? cateringPink : data?.About?.image1} alt="" whileHover={{ scale: 1.02 }} transition={{ duration: 0.5 }} />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ SERVICES ═══════════════ */}
      <section className="ev-section" id="servicesid">
        <div className="ev-watermark ev-watermark--left">Services.</div>
        <div className="container">
          <Reveal className="ev-section-header" y={20} duration={0.8}>
            <span className="ev-section-tag">
              <span className="ev-section-tag-dot" />
              {tr("Our Services", "Nos Services", "خدماتنا")}
            </span>
            <h2 className="ev-section-title">
              {tr("Premium Event Solutions", "Solutions événementielles premium", "حلول فعاليات متميزة")}
            </h2>
            <p className="ev-section-sub" style={{ maxWidth: 700 }}>
              {tr(
                "When it comes to finding the right entertainment to dazzle your guests and create a truly memorable experience, HMA Event Planners are here to enhance the theme of your event and add a unique touch. HMA Event Planners have endless and distinctive ideas to deliver top-notch entertainment, giving your guests an opportunity to remember your event for a long time.",
                "Quand il s'agit de trouver le bon divertissement pour éblouir vos invités et créer une expérience vraiment mémorable, HMA Event Planners est là pour embellir le thème de votre événement et ajouter une touche unique.",
                "عندما يتعلق الأمر بالعثور على الترفيه المناسب لإبهار ضيوفك وخلق تجربة لا تنسى حقًا، مؤسسة إتش أم أي للمؤتمرات و المعارض و المناسبات و الخدمات تخطط للحدث وتضيف لمسة فريدة من نوعها."
              )}
            </p>
          </Reveal>

          <Reveal y={20} duration={0.8}>
            <div className="ev-services-grid">
              {servicesList.map((svc, i) => (
                <motion.div
                  key={svc}
                  className="ev-service-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  whileHover={{ y: -6 }}
                >
                  <h4 className="ev-service-card-title">
                    {svc === "CONFERENCE" ? tr("CONFERENCE", "CONFÉRENCE", "مؤتمر") :
                     svc === "EXHIBITION" ? tr("EXHIBITION", "EXPOSITION", "معرض") :
                     svc === "WEDDING" ? tr("WEDDING", "MARIAGE", "زفاف") :
                     svc === "CATERING" ? tr("CATERING", "TRAITEUR", "تقديم الطعام") :
                     svc === "INSURANCE" ? tr("INSURANCE", "ASSURANCE", "تأمين") :
                     svc === "SERVICES" ? tr("SERVICES", "SERVICES", "خدمات") :
                     svc === "MEDIA" ? tr("MEDIA", "MÉDIA", "وسائل الإعلام") : svc}
                  </h4>
                  <div className="ev-service-card-line" />
                </motion.div>
              ))}
            </div>
          </Reveal>

          <div className="ev-service-detail-grid">
            <Reveal y={20} duration={0.8} delay={0.2}>
              <motion.div
                className="ev-service-detail"
                whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.01 : 1.005 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                onClick={() => window.matchMedia("(max-width: 991px)").matches && setServiceModal("planning")}
              >
                <div className="ev-service-detail-img-wrap">
                  <motion.img
                    src={planningDining}
                    alt="Event Planning"
                    className="ev-service-detail-img"
                    whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.03 : 1.06 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  />
                </div>
                <div className="ev-service-detail-text">
                  <div className="ev-service-detail-num">01</div>
                  <h3 className="ev-service-detail-title">
                    {tr("Event Planning", "Planification d'événements", "التخطيط")}
                  </h3>
                  <div className="ev-service-detail-accent" />
                  <p className="ev-service-detail-desc">
                    {tr(
                      "From selecting the perfect venue to an imaginative theme, we take care of every detail to make your event a stress free, seamlessly managed occasion.",
                      "De la sélection du lieu parfait à un thème imaginatif, nous nous occupons de chaque détail.",
                      "عنــد زيــارة مــكان الحــدث، يمكننــا تقديــم نظــرة فنيــة لمســاعدة العميــل."
                    )}
                  </p>
                </div>
                <div className="ev-service-detail-arrow">→</div>
              </motion.div>
            </Reveal>

            <Reveal y={20} duration={0.8} delay={0.3}>
              <motion.div
                className="ev-service-detail ev-service-detail--reverse"
                whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.01 : 1.005 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                onClick={() => window.matchMedia("(max-width: 991px)").matches && setServiceModal("media")}
              >
                <div className="ev-service-detail-img-wrap">
                  <motion.img
                    src={cameraStudio}
                    alt="HMA Media"
                    className="ev-service-detail-img"
                    whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.03 : 1.06 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  />
                </div>
                <div className="ev-service-detail-text">
                  <div className="ev-service-detail-num">02</div>
                  <h3 className="ev-service-detail-title">
                    {tr("HMA Media", "HMA Media", "إتش أم أي ميديا")}
                  </h3>
                  <div className="ev-service-detail-accent" />
                  <p className="ev-service-detail-desc">
                    {tr(
                      "Professional media coverage including photography, videography, livestreaming and social media amplification to maximize your event's reach.",
                      "Couverture médiatique professionnelle incluant photographie, vidéographie, streaming en direct.",
                      "تغطية إعلامية احترافية تشمل التصوير الفوتوغرافي والفيديو والبث المباشر."
                    )}
                  </p>
                  </div>
                <div className="ev-service-detail-arrow">→</div>
              </motion.div>
            </Reveal>

            <Reveal y={20} duration={0.8} delay={0.4}>
              <motion.div
                className="ev-service-detail"
                whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.01 : 1.005 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                onClick={() => window.matchMedia("(max-width: 991px)").matches && setServiceModal("decor")}
              >
                <div className="ev-service-detail-img-wrap">
                  <motion.img
                    src={decorPurpleTree}
                    alt="Event Décor"
                    className="ev-service-detail-img"
                    whileHover={{ scale: window.matchMedia("(max-width: 991px)").matches ? 1.03 : 1.06 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  />
                </div>
                <div className="ev-service-detail-text">
                  <div className="ev-service-detail-num">03</div>
                  <h3 className="ev-service-detail-title">
                    {tr("Event Design & Décor", "Design et Décoration", "التصميم و الديكور")}
                  </h3>
                  <div className="ev-service-detail-accent" />
                  <p className="ev-service-detail-desc">
                    {tr(
                      "The right venue goes a long way towards setting the tone, but it's the décor that allows us to create an atmosphere and set the stage for something spectacular.",
                      "Le bon lieu contribue à créer l'ambiance, mais c'est la décoration qui nous permet de créer une atmosphère.",
                      "نضع على ذمتكم مصممين ذو خبرة عالية في شتى المناسبات من الكلاسيكية إلى الحديثة."
                    )}
                  </p>
                  </div>
                <div className="ev-service-detail-arrow">→</div>
              </motion.div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ PORTFOLIO GALLERY ═══════════════ */}
      <section className="ev-section ev-section-alt" id="galleryid">
        <div className="container">
          <Reveal className="ev-section-header" y={20} duration={0.8}>
            <span className="ev-section-tag">
              <span className="ev-section-tag-dot" />
              {tr("Our Portfolio", "Notre Portfolio", "معرض أعمالنا")}
            </span>
            <h2 className="ev-section-title">
              {tr("A glimpse into our world", "Un aperçu de notre monde", "نظرة على عالمنا")}
            </h2>
          </Reveal>

          <Reveal y={16} duration={0.6}>
            <div className="ev-gallery-filters">
              {galleryFilters.map((f) => (
                <button
                  key={f}
                  className={`ev-gallery-filter-btn ${activeFilter === f ? "is-active" : ""}`}
                  onClick={() => setActiveFilter(f)}
                >
                  {f === "All" ? tr("All", "Tous", "الكل") :
                   f === "Conference" ? tr("Conference", "Conférence", "مؤتمر") :
                   f === "Wedding" ? tr("Wedding", "Mariage", "زفاف") :
                   f === "Exhibition" ? tr("Exhibition", "Exposition", "معرض") :
                   f === "Diplomatic" ? tr("Diplomatic", "Diplomatique", "دبلوماسي") :
                   f === "Media" ? tr("Media", "Média", "إعلام") :
                   f === "Events" ? tr("Events", "Événements", "فعاليات") : f}
                </button>
              ))}
            </div>
          </Reveal>

          <Reveal y={20} duration={0.8}>
            <motion.div className="ev-gallery-grid" layout>
              {filteredGallery.slice(0, galleryCount).map((img, i) => (
                <motion.div
                  key={img.title + i}
                  className="ev-gallery-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-30px" }}
                  transition={{ duration: 0.35, delay: (i % 8) * 0.04 }}
                  whileHover={{ y: -6 }}
                  onClick={() => setPortfolioLightbox(img)}
                >
                  <img src={img.src} alt={img.title} />
                  <div className="ev-gallery-overlay">
                    <span className="ev-gallery-tag">
                      {img.tag === "Conference" ? tr("Conference", "Conférence", "مؤتمر") :
                       img.tag === "Wedding" ? tr("Wedding", "Mariage", "زفاف") :
                       img.tag === "Exhibition" ? tr("Exhibition", "Exposition", "معرض") :
                       img.tag === "Diplomatic" ? tr("Diplomatic", "Diplomatique", "دبلوماسي") :
                       img.tag === "Media" ? tr("Media", "Média", "إعلام") :
                       img.tag === "Production" ? tr("Production", "Production", "إنتاج") :
                       img.tag === "Forum" ? tr("Forum", "Forum", "منتدى") :
                       img.tag === "Summit" ? tr("Summit", "Sommet", "قمة") :
                       img.tag === "Planning" ? tr("Planning", "Planification", "تخطيط") :
                       img.tag === "Décor" ? tr("Décor", "Décoration", "ديكور") :
                       img.tag === "Catering" ? tr("Catering", "Traiteur", "تقديم الطعام") :
                       img.tag === "Sports" ? tr("Sports", "Sports", "رياضة") :
                       img.tag === "National Day" ? tr("National Day", "Fête nationale", "اليوم الوطني") :
                       img.tag === "Inauguration" ? tr("Inauguration", "Inauguration", "افتتاح") :
                       img.tag === "Outdoor" ? tr("Outdoor", "Plein air", "خارجي") :
                       img.tag === "Corporate" ? tr("Corporate", "Entreprise", "شركة") :
                       img.tag === "Gala" ? tr("Gala", "Gala", "حفل") :
                       img.tag === "Portfolio" ? tr("Portfolio", "Portfolio", "أعمال") : img.tag}
                    </span>
                    <span className="ev-gallery-title">{img.title}</span>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </Reveal>

          {galleryCount < filteredGallery.length && (
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <button
                className="ev-btn-primary"
                onClick={() => setGalleryCount((p) => p + 12)}
                style={{ cursor: "pointer", border: "none" }}
              >
                {tr("Load More", "Voir plus", "عرض المزيد")}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* ═══════════════ PROJECTS ═══════════════ */}
      <section className="ev-section" id="projectsid">
        <div className="container">
          <Reveal className="ev-section-header" y={20} duration={0.8}>
            <span className="ev-section-tag">
              <span className="ev-section-tag-dot" />
              {tr("Latest Project", "Dernier Projet", "أحدث مشروع")}
            </span>
            <h2 className="ev-section-title">
              {tr("Award Winning ", "Projets Primés ", "مشاريع حائزة ")}
              <em style={{ fontStyle: "normal", color: "var(--ev-gold)" }}>
                {tr("Projects", "Exceptionnels", "على جوائز")}
              </em>
            </h2>
            <p className="ev-section-sub">
              {tr("Click on any project to view details and imagery.", "Cliquez sur un projet pour voir les détails.", "اضغط على أي مشروع لعرض التفاصيل.")}
            </p>
          </Reveal>

          <div className="ev-projects-grid">
            {projects.map((e, i) => (
              <Reveal key={i} y={30} delay={0.06 + i * 0.06}>
                <motion.div
                  className="ev-project-card"
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.4 }}
                  onClick={() => openProjectModal(e)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={e?.images?.[0] || about3} alt="project" className="ev-project-image" />
                  <div className="ev-project-body">
                    <h4 className="ev-project-name">
                      {lang.value === "EN" ? e?.name : lang.value === "FR" ? e?.nameFR : e?.nameAR}
                    </h4>
                    <p className="ev-project-client">
                      {lang.value === "EN" ? e?.client : lang.value === "FR" ? e?.clientFR : e?.clientAR}
                    </p>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>



      {/* ═══════════════ SPONSOR ═══════════════ */}
      {partners.length > 0 && (
        <div className="sponsor style-two">
          <div className="container">
            <Swiper slidesPerView={3} spaceBetween={30}
              breakpoints={{ 500: { slidesPerView: 2, spaceBetween: 20 }, 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 3, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 30 } }}
              pagination={{ clickable: true }} className="mySwiper"
            >
              {partners.map((e, i) => (
                <SwiperSlide key={i} className="swiper-slide">
                  <div><img src={e?.image} alt="" width={150} /></div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}

      {/* ═══════════════ CONTACT ═══════════════ */}
      <section className="ev-section ev-section-alt" id="contactid">
        <div className="container">
          <Reveal className="ev-section-header" y={20} duration={0.8}>
            <span className="ev-section-tag">
              <span className="ev-section-tag-dot" />
              {tr("Get In Touch", "Entrer en contact", "تواصل معنا")}
            </span>
            <h2 className="ev-section-title">
              {tr("Let's discuss your next event", "Discutons de votre prochain événement", "دعنا نناقش فعاليتك القادمة")}
            </h2>
          </Reveal>

          <div className="ev-contact-grid">
            <Reveal y={20} duration={0.8}>
              <div className="ev-contact-info">
                {[
                  { icon: <Phone size={20} />, label: tr("Phone", "Téléphone", "الهاتف"), value: config?.phone, href: `tel:${config?.phone}` },
                  { icon: <Mail size={20} />, label: tr("Email", "Email", "البريد الإلكتروني"), value: config?.email, href: `mailto:${config?.email}` },
                  { icon: <MapPin size={20} />, label: tr("Address", "Adresse", "العنوان"), value: tr(config?.address, config?.addressFR, config?.addressAR) },
                  { icon: <Clock size={20} />, label: tr("Working Hours", "Heures d'ouverture", "ساعات العمل"), value: `${config?.openingDayStart} - ${config?.openingDayEnd}, ${config?.openingHourStart} - ${config?.openingHourEnd}` },
                ].map((item, i) => (
                  <motion.div key={i} className="ev-contact-item"
                    initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                  >
                    <div className="ev-contact-icon">{item.icon}</div>
                    <div>
                      <div className="ev-contact-label">{item.label}</div>
                      <div className="ev-contact-value">{item.href ? <a href={item.href}>{item.value}</a> : item.value}</div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </Reveal>

            <Reveal y={20} duration={0.8} delay={0.15}>
              <form className="ev-form" onSubmit={(e) => e.preventDefault()}>
                <div className="ev-form-row">
                  <input type="text" className="ev-form-input" placeholder={tr("Full Name", "Nom complet", "الاسم الكامل")} onChange={(e) => setfullName(e.target.value)} />
                  <input type="email" className="ev-form-input" placeholder={tr("Email Address", "Adresse email", "البريد الإلكتروني")} onChange={(e) => setemail(e.target.value)} />
                </div>
                <div className="ev-form-row">
                  <input type="text" className="ev-form-input" placeholder={tr("Phone Number", "Numéro de téléphone", "رقم الهاتف")} onChange={(e) => setphone(e.target.value)} />
                  <input type="text" className="ev-form-input" placeholder={tr("Skype Address", "Adresse Skype", "عنوان سكايب")} onChange={(e) => setskype(e.target.value)} />
                </div>
                <textarea className="ev-form-textarea" placeholder={tr("Your Message", "Votre message", "رسالتك")} onChange={(e) => setmessage(e.target.value)} />
                <button type="submit" className="ev-form-submit" onClick={(e) => addContact(e)}>
                  {tr("Send Message", "Envoyer le message", "إرسال الرسالة")}
                  <ArrowUpRight size={18} style={{ marginLeft: 8 }} />
                </button>
              </form>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ MAP ═══════════════ */}
      <div className="contact__map">
        <div id="map">
          <iframe
            className="google__map w-100"
            src="https://maps.google.com/maps?q=QFC%20tower%2C%20Doha-Qatar&t=m&z=11&output=embed&iwloc=near"
            title="HMA Location"
            style={{ width: "100%", height: "100%", border: "none", display: "block" }}
          />
        </div>
      </div>

      {/* ═══════════════ FOOTER ═══════════════ */}
      <footer className="footer pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{tr("Contact Us", "Contactez-nous", "اتصل بنا")}</h5>
                <div className="footer__widget--contact">
                  <ul>
                    <li>
                      <i className="fa-sharp fa-solid fa-phone" />
                      <a href={`tel:${config?.phone}`}>{config?.phone}</a>
                    </li>
                    <li>
                      <i className="fa-regular fa-envelope" />
                      <a href={`mailto:${config?.email}`}>{config?.email}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{tr("Links", "Liens", "الروابط")}</h5>
                <div className="footer__widget--link">
                  <ul>
                    <li><a href="#homeid">{tr("Home", "Accueil", "الصفحة الرئيسية")}</a></li>
                    <li><a href="#aboutid">{tr("About", "À propos", "معلومات عنا")}</a></li>
                    <li><a href="#servicesid">{tr("Services", "Services", "خدمات")}</a></li>
                    <li><a href="#projectsid">{tr("Portfolio", "Portefeuille", "المشاريع")}</a></li>
                    <li><a href="#contactid">{tr("Contact", "Contact", "اتصال")}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{tr("Newsletter", "Bulletin", "نشرة")}</h5>
                <div className="footer__widget--newsletter">
                  <p>
                    {tr(
                      "Stay updated with our latest events and exclusive offers.",
                      "Restez informé de nos événements et offres exclusives.",
                      "ابق على اطلاع بأحدث فعالياتنا وعروضنا الحصرية."
                    )}
                  </p>
                  <form action="#" className="newsletter-box">
                    <input type="email" placeholder="" />
                    <button type="submit">
                      {tr("Submit", "Soumettre", "إرسال")}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-credit">
        <div className="container">
          <div className="footer-credit--img">
            <a href="#homeid" onClick={navHash("homeid")}>
              <img src={Logo} alt="footer logo" />
            </a>
          </div>
          <div className="footer-credit__wrapper mt-25">
            <div className="copy-right">
              {tr("Copyright", "Copyright", "حقوق الطبع والنشر")} &copy; {new Date().getFullYear()} — <a href="#">HMA Events</a> {tr("All Rights Reserved", "Tous droits réservés", "جميع الحقوق محفوظة")}
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════════ SERVICE MODAL ═══════════════ */}
      <Modal isOpen={modalopen} toggle={() => setmodalopen(!modalopen)} className="my-modal" centered size="lg">
        <ModalBody>
          <h4 style={{ color: "#1a1a1a" }}>{lang.value === "EN" ? item?.title : lang.value === "FR" ? item?.titleFR : item?.titleAR}</h4>
          <p style={{ color: "rgba(26,26,26,0.7)", lineHeight: 1.8 }}>
            {lang.value === "EN" ? item?.description : lang.value === "FR" ? item?.descriptionFR : item?.descriptionAR}
          </p>
        </ModalBody>
      </Modal>

      {/* ═══════════════ PROJECT MODAL ═══════════════ */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            key="project-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={closeProjectModal}
            className="ev-project-modal-overlay"
          >
            <motion.div
              key="modal-card"
              initial={{ opacity: 0, scale: 0.92, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 30 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="ev-project-modal-card"
            >
              <button type="button" className="ev-modal-close" onClick={closeProjectModal}>
                ✕
              </button>

              <div className="ev-project-modal-image">
                <img src={selectedProject?.images?.[0] || about3} alt="project" />
                <div className="ev-project-modal-image-overlay" />
                <div className="ev-project-modal-image-accent" />
              </div>

              <div className="ev-project-modal-body">
                <span className="ev-project-modal-tag">
                  {lang.value === "EN" ? "Featured Project" : lang.value === "FR" ? "Projet à la une" : "مشروع مميز"}
                </span>
                <h3 className="ev-project-modal-title">
                  {lang.value === "EN" ? selectedProject?.name : lang.value === "FR" ? selectedProject?.nameFR : selectedProject?.nameAR}
                </h3>
                <p className="ev-project-modal-client">
                  {lang.value === "EN" ? selectedProject?.client : lang.value === "FR" ? selectedProject?.clientFR : selectedProject?.clientAR}
                </p>
                <div className="ev-project-modal-divider" />
                <p className="ev-project-modal-desc">
                  {lang.value === "EN" ? selectedProject?.description : lang.value === "FR" ? selectedProject?.descriptionFR : selectedProject?.descriptionAR}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ═══════════════ SERVICE MODAL ═══════════════ */}
      <AnimatePresence>
        {serviceModal && (
          <motion.div
            key="service-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={() => setServiceModal(null)}
            className="ev-project-modal-overlay"
          >
            <motion.div
              key="service-modal-card"
              initial={{ opacity: 0, scale: 0.92, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 30 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="ev-project-modal-card"
            >
              <button type="button" className="ev-modal-close" onClick={() => setServiceModal(null)}>
                ✕
              </button>

              {(() => {
                const modalData = {
                  planning: {
                    img: planningDining,
                    titleEN: "Event Planning", titleFR: "Planification d'événements", titleAR: "التخطيط",
                    tagEN: "Event Planning", tagFR: "Planification", tagAR: "تخطيط",
                    descEN: "From selecting the perfect venue to an imaginative theme, we take care of every detail to make your event a stress free, seamlessly managed occasion for you and your guests to enjoy.",
                    descFR: "De la sélection du lieu parfait à un thème imaginatif, nous nous occupons de chaque détail.",
                    descAR: "عنــد زيــارة مــكان الحــدث، يمكننــا تقديــم نظــرة فنيــة لمســاعدة العميــل علــى اســتغلال مــكان الحــدث أفضــل مــا يمكن."
                  },
                  media: {
                    img: cameraStudio,
                    titleEN: "HMA Media", titleFR: "HMA Media", titleAR: "إتش أم أي ميديا",
                    tagEN: "Media Coverage", tagFR: "Couverture médiatique", tagAR: "تغطية إعلامية",
                    descEN: "Professional media coverage including photography, videography, livestreaming and social media amplification to maximize your event's reach and impact.",
                    descFR: "Couverture médiatique professionnelle incluant photographie, vidéographie, streaming en direct et amplification sur les réseaux sociaux.",
                    descAR: "تغطية إعلامية احترافية تشمل التصوير الفوتوغرافي والفيديو والبث المباشر والتضخيم عبر وسائل التواصل الاجتماعي."
                  },
                  decor: {
                    img: decorPurpleTree,
                    titleEN: "Event Design & Décor", titleFR: "Design et Décoration", titleAR: "التصميم و الديكور",
                    tagEN: "Design & Décor", tagFR: "Design et Décoration", tagAR: "تصميم و ديكور",
                    descEN: "The right venue goes a long way towards setting the tone for an event, but it's the décor that allows us to create an atmosphere, alter perception and set the stage for something spectacular. Our décor experts are masters of illusion who can transform any venue into something glamorous with a reflection of your style and theme.",
                    descFR: "Le bon lieu contribue à créer l'ambiance, mais c'est la décoration qui nous permet de créer une atmosphère. Nos experts en décoration sont des maîtres de l'illusion.",
                    descAR: "نضع على ذمتكم مصممين ذو خبرة عالية في شتى المناسبات من الكلاسيكية إلى الحديثة، ويبقى هدفنا الأسمى هو إرضاء العميل و إخراج الحدث في أبهى تجلياته."
                  }
                };
                const d = modalData[serviceModal];
                return (
                  <>
                    <div className="ev-project-modal-image">
                      <img src={d.img} alt={d.titleEN} />
                      <div className="ev-project-modal-image-overlay" />
                      <div className="ev-project-modal-image-accent" />
                    </div>
                    <div className="ev-project-modal-body">
                      <span className="ev-project-modal-tag">
                        {lang.value === "EN" ? d.tagEN : lang.value === "FR" ? d.tagFR : d.tagAR}
                      </span>
                      <h3 className="ev-project-modal-title">
                        {lang.value === "EN" ? d.titleEN : lang.value === "FR" ? d.titleFR : d.titleAR}
                      </h3>
                      <div className="ev-project-modal-divider" />
                      <p className="ev-project-modal-desc">
                        {lang.value === "EN" ? d.descEN : lang.value === "FR" ? d.descFR : d.descAR}
                      </p>
                    </div>
                  </>
                );
              })()}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ═══════════════ PORTFOLIO LIGHTBOX ═══════════════ */}
      {portfolioLightbox && (
        <div className="gallery-lightbox" onClick={() => setPortfolioLightbox(null)}>
          <button type="button" className="close-btn" aria-label="close" onClick={() => setPortfolioLightbox(null)}>
            <i className="fa-sharp fa-light fa-xmark" />
          </button>
          <img src={portfolioLightbox.src} alt={portfolioLightbox.title || ""} />
          {portfolioLightbox.title && (
            <div style={{ position: "absolute", bottom: 30, left: "50%", transform: "translateX(-50%)", color: "#fff", fontSize: 16, fontWeight: 600, textAlign: "center", background: "rgba(0,0,0,0.5)", padding: "10px 24px", borderRadius: 999, backdropFilter: "blur(8px)" }}>
              {portfolioLightbox.tag && <span style={{ color: "#c9a14a", fontSize: 12, display: "block", marginBottom: 2 }}>
                {portfolioLightbox.tag === "Conference" ? tr("Conference", "Conférence", "مؤتمر") :
                 portfolioLightbox.tag === "Wedding" ? tr("Wedding", "Mariage", "زفاف") :
                 portfolioLightbox.tag === "Exhibition" ? tr("Exhibition", "Exposition", "معرض") :
                 portfolioLightbox.tag === "Diplomatic" ? tr("Diplomatic", "Diplomatique", "دبلوماسي") :
                 portfolioLightbox.tag === "Media" ? tr("Media", "Média", "إعلام") :
                 portfolioLightbox.tag === "Production" ? tr("Production", "Production", "إنتاج") :
                 portfolioLightbox.tag === "Forum" ? tr("Forum", "Forum", "منتدى") :
                 portfolioLightbox.tag === "Summit" ? tr("Summit", "Sommet", "قمة") :
                 portfolioLightbox.tag === "Planning" ? tr("Planning", "Planification", "تخطيط") :
                 portfolioLightbox.tag === "Décor" ? tr("Décor", "Décoration", "ديكور") :
                 portfolioLightbox.tag === "Catering" ? tr("Catering", "Traiteur", "تقديم الطعام") :
                 portfolioLightbox.tag === "Sports" ? tr("Sports", "Sports", "رياضة") :
                 portfolioLightbox.tag === "National Day" ? tr("National Day", "Fête nationale", "اليوم الوطني") :
                 portfolioLightbox.tag === "Inauguration" ? tr("Inauguration", "Inauguration", "افتتاح") :
                 portfolioLightbox.tag === "Outdoor" ? tr("Outdoor", "Plein air", "خارجي") :
                 portfolioLightbox.tag === "Corporate" ? tr("Corporate", "Entreprise", "شركة") :
                 portfolioLightbox.tag === "Gala" ? tr("Gala", "Gala", "حفل") :
                 portfolioLightbox.tag === "Portfolio" ? tr("Portfolio", "Portfolio", "أعمال") : portfolioLightbox.tag}
              </span>}
              {portfolioLightbox.title}
            </div>
          )}
        </div>
      )}

      {lightbox && (
        <div className="gallery-lightbox" onClick={() => setLightbox(null)}>
          <button type="button" className="close-btn" aria-label="close" onClick={() => setLightbox(null)}>
            <i className="fa-sharp fa-light fa-xmark" />
          </button>
          <img src={lightbox.src} alt={lightbox.title} />
        </div>
      )}
    </div>
  );
};

export default Events;
